export default __webpack_public_path__ + "static/media/youtube.618cc599.svg";